import { inject } from '@angular/core'
import { CanActivateFn } from '@angular/router'
import { UsuarioService } from '../services/usuario.service'
import { StorageService } from '../services/storage.service'

function isTokenValid(token: string): boolean {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) return false

    const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')))
    if (!payload.exp) return false

    return Math.floor(Date.now() / 1000) < payload.exp
  } catch {
    return false
  }
}

export const authGuard: CanActivateFn = () => {
  const usuarioService = inject(UsuarioService)
  const storage = inject(StorageService)
  const token = storage.getToken()

  if (!token || !isTokenValid(token)) {
    usuarioService.timeout()
    return false
  }

  return true
}
